import type {
	SizeGuideFamily,
	SizeGuideLine,
} from '../../types/SizeGuide.types'

export interface ParsedOption {
	text: string
	value: string
}

export const getParsedOptions = (
	options: SizeGuideLine[] | SizeGuideFamily[]
): ParsedOption[] =>
	options.map((option) => ({ text: option.label, value: option.id }))
